import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import { TypeAsserter } from '@attain-apps/type-guards'

import type { TypeParams } from './types'

export default ec.associations.create<TypeParams>(function (assignedRecord) {
  const { spaceRecordIds } = assignedRecord as FlattenUnion<typeof assignedRecord>
  this.select({
    collection: ec.Name.Predefined.SpaceClusterAssignableRecord,
    ids: spaceRecordIds ?? [],
    update: (
      updatedEntity: typeof assignedRecord,
      updatedIds: readonly ec.models.EntityId[],
    ) => {
      const _updatedEntity = updatedEntity as FlattenUnion<typeof updatedEntity>
      _updatedEntity.spaceRecordIds = updatedIds.map(id =>
        TypeAsserter.validateButJustWarn(
          id,
          ents.extra.space.Record.Id.assertIsId,
        ),
      )
    },
  })
})
